



















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import echarts from 'echarts/index.common'
import { TOKEN, SO_FAR } from '@/store/mutation-types'
import PageLayout from '@/components/page/PageLayout.vue'
import { uuid, dateFormat, throttle, download } from '@/utils/util'
import moment from 'moment'
import EvaluateApi from '@/api/evaluate'
import ImageInfo from '../../AiiTasks/ImageInfo.vue'
import tabs from '../../AiiTasks/Tabs.vue'
import bus from '../../AiiTasks/bus'
import orderList from './orderList.vue'
import PartnerApi from '@/api/partner'
import { wsURL } from '@/api/url'

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

@Component({
	name: 'partnerDetail',
	components: {
		PageLayout,
		ImageInfo,
		tabs,
		orderList,
	},
})
export default class QueryList extends Vue {
	private addResurveyVisible: boolean = false
	private taskLog: any = []
	private taskLogVisible: boolean = false
	private order: any = {}
	private injured: any = {}
	private returnVisible: boolean = false
	private returnLoading: boolean = false
	private returnForm: any = {}
	private mediaOrder: any = []
	private mediaMap: any = {}
	private mediaInfoMap: any = {}
	private ws: any = ''
	private activeKey: any = '1'
	private timer: any = ''
	private expireTimer: any = ''
	private throttleOpenWS = throttle(10 * 1000)
	private once: boolean = false
	private exporting: boolean = false
	private visitorPhone: any = ''
	private cancelLoading: boolean = false
	private revokeDialogVisible: boolean = false
	private cancelForm: any = {}
	private auditCancelForm: any = {}
	private evaluateForm: any = {}
	private evaluateVisible: boolean = false
	private evaluateLoading: boolean = false
	private rate: number = 5
	private labelMap: any = {}
	private labelList: any = []
	private evaluateInfo: any = {}
	private auditCancelVisible: boolean = false
	private auditCancelLoading: boolean = false
	private postponeVisible: boolean = false
	private postponeLoading: boolean = false
	private postponeHours: any = 12
	private show: any = ''
	private resurveyCountdown: any = 0
	private canResurvey: boolean = false
	private lastOrderInfo: any = ''
	private addForm: any = {}
	private addLoading: boolean = false
	private detail: any = ''

	private getDescription(item: any) {
		if (['6', '7', '20'].includes(item.taskStatus)) {
			return `${item.company} ${item.creator} ${item.desciption}`
		} else {
			return item.desciption
		}
	}

	private resurvey() {
		this.addResurveyVisible = true
	}

	private onTaskAdd() {
		this.getDetail().then(() => {
			this.getOrderExStatusInfo()
		})
		bus.$emit('addTask')
	}

	private getNumStr(num: any) {
		if (num || num === 0) {
			return num + '单'
		}
		return '--'
	}

	private back() {
		this.$router.go(-1)
	}

	private get canEvaluate() {
		const evStatus = this.evaluateInfo.evStatus
		const accessUserId = this.evaluateInfo.accessUserId
		if (evStatus && evStatus === '0') {
			if (accessUserId === this.$store.state.user.userInfo.userId) {
				return true
			}
			if (accessUserId === '-1') {
				if (
					this.order.creator === this.$store.state.user.userInfo.userId ||
					this.$auth('taskDetail:auditTask')
				) {
					return true
				}
			}
		}
		return false
	}

	private deAuditCancel() {
		this.auditCancelForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.auditCancelLoading = true
				const copy = {
					...values,
					orderId: this.$route.params.orderId,
					pass: 0,
				}
				TaskApi.auditCancelTask(copy)
					.then((res: any) => {
						this.$message.success('撤单申请已拒绝')
						this.auditCancelVisible = false
						this.getDetail()
					})
					.finally(() => {
						this.auditCancelLoading = false
					})
			}
		})
	}

	private auditCancelReject() {
		this.auditCancelVisible = true
		this.auditCancelForm.resetFields()
	}

	private auditCancelPass() {
		this.$confirm({
			title: '提示',
			content: `确认同意撤单吗?`,
			onOk: () => {
				return TaskApi.auditCancelTask({
					orderId: this.$route.params.orderId,
					pass: 1,
				}).then((res: any) => {
					this.$message.success('撤单申请已同意')
					this.getDetail()
				})
			},
		})
	}

	private getEvaluate() {
		return EvaluateApi.getEvaluate({
			businessId: this.$route.params.orderId,
			evType: 'insurance',
		}).then((res: any) => {
			this.labelList = []
			this.labelMap = {}
			this.rate = 5
			this.evaluateForm.resetFields()
			if (res.data[0]) {
				this.evaluateInfo = res.data[0]
				this.labelList = res.data[0].labels
			}
		})
	}

	private chcekPass() {
		this.$confirm({
			title: '提示',
			content: '确认审核通过吗 ?',
			onOk: () => {
				return TaskApi.checkTask({
					orderId: this.$route.params.orderId,
					pass: '1',
				}).then((res: any) => {
					this.getDetail()
					this.$message.success('审核通过成功')
				})
			},
		})
	}

	private choose(i: any) {
		this.rate = i
	}

	private zeroUnit(val: any, unit: string = '元') {
		if (val === 0 || val) {
			return val + unit
		} else {
			return
		}
	}

	private evaluateOrder() {
		const id = this.evaluateInfo.id
		EvaluateApi.saveEvaluate({
			id,
			userId: this.$store.state.user.userInfo.userId,
			urerName: this.$store.state.user.userInfo.userName,
			score: this.rate,
			comment: this.evaluateForm.getFieldValue('comment'),
			labels: this.labelList
				.map((item: any) => item.id)
				.filter((item: any) => this.labelMap[item]),
		}).then((res: any) => {
			this.$message.success('评价完成')
			this.evaluateVisible = false
			this.getEvaluate()
		})
	}

	private cancelOrder() {
		this.revokeDialogVisible = true
		this.cancelForm.resetFields()
	}

	private postponeOrder() {
		this.postponeHours = 12
		this.postponeVisible = true
	}

	private postponeOk() {
		if (!this.postponeHours) {
			return this.$message.error('请选择订单延长时长')
		}
		return TaskApi.postponeOrder({
			orderId: this.$route.params.orderId,
			hours: this.postponeHours,
		}).then(() => {
			this.postponeVisible = false
			this.$message.success('延期成功')
			this.getDetail()
		})
	}

	private cancelOk() {
		this.cancelForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.cancelLoading = true
				const copy = {
					...values,
					orderId: this.$route.params.orderId,
				}
				TaskApi.cancelOrder(copy)
					.then((res: any) => {
						this.$message.success('撤销成功')
						this.revokeDialogVisible = false
						this.getDetail()
					})
					.finally(() => {
						this.cancelLoading = false
					})
			}
		})
	}

	private renderChart(data: any) {
		data = data.reverse()
		var mychart = echarts.init(document.getElementById('chart'))
		var open = {
			grid: {
				left: '4%',
				right: '2%',
				top: '8%',
				bottom: '4%',
			},
			color: ['#42B983', '#56AFDA', '#C88009', '#E28FDB'],
			xAxis: {
				boundaryGap: true,
				axisTick: {
					alignWithLabel: true,
				},
				data: data.map((item: any) => {
					return item.orderDt
				}),
			},
			yAxis: {},
			tooltip: {
				padding: 12,
				trigger: 'axis', // 触发类型，默认数据触发，见下图，可选为：'item' | 'axis'
			},
			legend: {
				data: ['新增订单', '完成订单', '超时订单', '审核退回订单'],
			},
			series: [
				{
					name: '新增订单',
					type: 'line',
					smooth: true,
					data: data.map((item: any) => {
						return item.dispatchSucNum
					}),
				},
				{
					name: '完成订单',
					type: 'line',
					smooth: true,
					data: data.map((item: any) => {
						return item.finishNum
					}),
				},
				{
					name: '超时订单',
					type: 'line',
					smooth: true,
					data: data.map((item: any) => {
						return item.overTimeNum
					}),
				},
				{
					name: '审核退回订单',
					type: 'line',
					smooth: true,
					data: data.map((item: any) => {
						return item.lastBackNum
					}),
				},
			],
		}
		mychart.setOption(open, true)
	}

	private mounted() {}

	private soFarDate(date: any) {
		if (date) {
			if (date < SO_FAR) {
				return moment(this.injured.injuredInfo.leaveDate).format('YYYY-MM-DD')
			} else {
				return '至今'
			}
		} else {
			return
		}
	}

	private dateFormat(start: any, end: any) {
		return dateFormat(start, end)
	}

	private getDetail() {
		return PartnerApi.getPartnerDetail(this.$route.params.partnerId).then(
			(data: any) => {
				this.detail = data.data
			}
		)
	}

	private created() {
		this.returnForm = this.$form.createForm(this)
		this.addForm = this.$form.createForm(this)
		this.cancelForm = this.$form.createForm(this)
		this.evaluateForm = this.$form.createForm(this)
		this.auditCancelForm = this.$form.createForm(this)
	}

	private deactivated() {
		this.show = ''
		this.activeKey = '1'
		this.ws && this.ws.close()
	}

	private openWS() {
		if (!this.order.orderNo) {
			return
		}
		TaskApi.getMsgToken(this.order.orderNo).then((res: any) => {
			if (res.code !== 200) {
				return
			}
			const msgToken = res.data
			const ws = new WebSocket(wsURL)
			this.ws = ws
			ws.onmessage = (event: any) => {
				try {
					const data: any = JSON.parse(event.data)
					if (data.content) {
						const content: any = JSON.parse(JSON.parse(data.content))
						if (content.status && content.status !== this.order.orderStatus) {
							this.getDetail()
						}
					}
				} catch (e) {
					//
				}
			}
			ws.onopen = () => {
				ws.send(
					JSON.stringify({
						requestId: uuid(),
						requestTime: moment().format('YYYY-MM-DD HH:mm:ss'),
						version: 'V1.0',
						data: {
							msgToken,
						},
					})
				)
				this.timer = setInterval(() => {
					ws.send('ping')
				}, 9 * 1000)
				this.expireTimer = setTimeout(() => {
					TaskApi.expireToken(this.order.orderNo)
				}, 29 * 60 * 1000)
			}
			ws.onclose = () => {
				clearTimeout(this.timer)
				clearTimeout(this.expireTimer)
				if (this.$route.name === 'AiiTaskDetail' && this.order.orderStatus) {
					this.throttleOpenWS(this.openWS)
				}
			}
		})
	}

	private activated() {
		this.detail = ''
		this.getDetail()
		this.getTrendOrderList()
	}

	private beforeRouteUpdate(to: any, from: any, next: any) {
		// 上个同动态路由组件收尾
		this.show = ''
		this.activeKey = '1'
		this.ws && this.ws.close()

		this.$nextTick(() => {
			// 获取下个动态路由组件信息
			this.detail = ''
			this.getDetail()
			this.getTrendOrderList()
		})
		next()
	}

	private getTrendOrderList() {
		return PartnerApi.getTrendOrderList({
			partnerId: this.$route.params.partnerId,
			pageNum: 1,
			pageSize: 10,
		}).then((res: any) => {
			const data = res.data.retList
			for (const item of data) {
				item.orderDt = moment(item.orderDt).format('MM-DD')
			}
			this.renderChart(data)
		})
	}

	private async getOrderExStatusInfo() {
		const res = await TaskApi.getOrderExStatusInfo(this.$route.params.orderId)
		const data = res.data
		this.lastOrderInfo = data
		this.canResurvey = data.canCreateNewOrder && this.$auth('taskList:add')
		if (data.lastSubmitTime) {
			const today = new Date(this.order.serverTime)
			const last = new Date(data.lastSubmitTime)

			const countdown = moment([
				today.getFullYear(),
				today.getMonth(),
				today.getDate(),
			]).diff(
				moment([last.getFullYear(), last.getMonth(), last.getDate()]),
				'days'
			)

			this.resurveyCountdown = countdown + 1
		} else {
			this.resurveyCountdown = false
		}
	}

	private onTabsChange(activeKey: string) {
		this.activeKey = activeKey
		window.scrollTo(0, 0)
	}

	private getTaskLog() {
		TaskApi.getTaskLog(this.$route.params.orderId).then((res: any) => {
			this.taskLog = res.data
			this.taskLogVisible = true
		})
	}

	private auditTaskPass() {
		const order = this.order
		this.$confirm({
			title: '提示',
			content: '确认审核通过吗 ?',
			onOk: () => {
				return TaskApi.auditTask({
					id: order.operationId,
					orderId: this.$route.params.orderId,
					status: '04',
					orderStatus: '05',
				}).then((res: any) => {
					this.getDetail()
					this.getEvaluate().then(() => {
						if (this.evaluateInfo.evStatus === '0') {
							this.evaluateVisible = true
						}
					})
				})
			},
		})
	}

	private auditTaskReturn() {
		this.returnForm.resetFields()
		this.returnVisible = true
	}

	private returnOk() {
		this.returnForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.returnLoading = true
				if (this.order.orderStatus === '04') {
					TaskApi.auditTask({
						id: this.order.operationId,
						orderId: this.$route.params.orderId,
						status: '01',
						orderStatus: '02',
						comment: values.comment,
					})
						.then((res: any) => {
							this.returnVisible = false
							this.getDetail()
							this.$message.success('审核退回成功')
						})
						.finally(() => {
							this.returnLoading = false
						})
				} else if (this.order.orderStatus === '031') {
					TaskApi.checkTask({
						orderId: this.$route.params.orderId,
						pass: '0',
						comment: values.comment,
					})
						.then((res: any) => {
							this.returnVisible = false
							this.getDetail()
							this.$message.success('审核退回成功')
						})
						.finally(() => {
							this.returnLoading = false
						})
				}
			}
		})
	}
}
